// "Meet the Makers" / Stars of Shopstar playlist.
// Source: https://www.youtube.com/playlist?list=PL0UmMVlK1tLGH4MFDbYea5iZEeTCSqkEt
export const PLAYLIST_URL = 'https://www.youtube.com/playlist?list=PL0UmMVlK1tLGH4MFDbYea5iZEeTCSqkEt';

export const MAKER_VIDEOS = [
  { id: 'fuhWG2QtTbE', maker: 'Marley Grey', title: 'Stars of Shopstar — Meet Marley Grey' },
  { id: 'pUGtw9JkeKc', maker: 'Vuyi Zondi', title: 'Stars of Shopstar — Meet Vuyi Zondi' },
  { id: 'LGZtxSTpOnc', maker: 'Janneman Solms', title: 'Stars of Shopstar — Meet Janneman Solms' },
  { id: 'SWs6RSYC0Gk', maker: 'Gary Jackson', title: 'Stars of Shopstar — Meet Gary Jackson' },
  { id: '_byec6gi3Mc', maker: 'KAMERS/Makers', title: 'Meet the makers from KAMERS/Makers' },
];
